const Freigaben: React.FC = () => {
  return <></>;
};

export default Freigaben;
